"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchSLAStatus = exports.updateResolutionTime = exports.updateTicketStatus = exports.replyTicketComment = exports.deleteTicket = exports.postTicket = exports.fetchTicket = exports.fetchTicketsByCompanyId = exports.fetchTicketsByUserId = exports.fetchTickets = void 0;
var axios_1 = require("axios");
var authConfig_1 = require("../authConfig");
var fetchTickets = function (pageNumber, searchStr, status) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, data, i, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket";
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = "".concat(BASE_URL).concat(API, "?rowsPerPage=25&pageNumber=").concat(pageNumber, "&searchStr=").concat(searchStr, "&status=").concat(status);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url)];
            case 2:
                response = _a.sent();
                data = response.data;
                for (i = 0; i < data.length; i++) {
                    data[i].key = i;
                }
                //data = data.map((item: any) => {
                //    return {
                //        key: item.key,
                //        id: item.ticketId,
                //        name: item.name,
                //        email: item.email,
                //        description: item.description,
                //        industry: item.industry,
                //        profilepic: item.logoUrl,
                //        displayName: item.displayName,
                //        phoneNumber: item.phoneNumber,
                //        status: convertStatusEnumToString(item.ticketId),
                //        address: item.address,
                //        purchasedLicenses: item.purchasedLicenses,
                //        purchasedServices: item.purchasedServices,
                //        purchasedSupports: item.purchasedSupports,
                //    }
                //});
                return [2 /*return*/, {
                        list: data.list,
                        count: data.totalRow,
                        page: pageNumber
                    }];
            case 3:
                e_1 = _a.sent();
                console.error(e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchTickets = fetchTickets;
var fetchTicketsByCompanyId = function (companyId) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, data, i, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/company/" + companyId;
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url)];
            case 2:
                response = _a.sent();
                data = response.data;
                for (i = 0; i < data.length; i++) {
                    data[i].key = i;
                }
                //data = data.map((item: any) => {
                //    return {
                //        key: item.key,
                //        id: item.ticketId,
                //        name: item.name,
                //        email: item.email,
                //        description: item.description,
                //        industry: item.industry,
                //        profilepic: item.logoUrl,
                //        displayName: item.displayName,
                //        phoneNumber: item.phoneNumber,
                //        status: convertStatusEnumToString(item.ticketId),
                //        address: item.address,
                //        purchasedLicenses: item.purchasedLicenses,
                //        purchasedServices: item.purchasedServices,
                //        purchasedSupports: item.purchasedSupports,
                //    }
                //});
                return [2 /*return*/, {
                        list: data,
                        count: data.length,
                        page: 1
                    }];
            case 3:
                e_2 = _a.sent();
                console.error(e_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchTicketsByCompanyId = fetchTicketsByCompanyId;
var fetchTicketsByUserId = function (userId, pageNumber, status) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, data, i, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/user/" + userId;
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = "".concat(BASE_URL).concat(API, "/rows/25/page/").concat(pageNumber, "?status=").concat(status);
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url)];
            case 2:
                response = _a.sent();
                data = response.data;
                for (i = 0; i < data.length; i++) {
                    data[i].key = i;
                }
                //data = data.map((item: any) => {
                //    return {
                //        key: item.key,
                //        id: item.ticketId,
                //        name: item.name,
                //        email: item.email,
                //        description: item.description,
                //        industry: item.industry,
                //        profilepic: item.logoUrl,
                //        displayName: item.displayName,
                //        phoneNumber: item.phoneNumber,
                //        status: convertStatusEnumToString(item.ticketId),
                //        address: item.address,
                //        purchasedLicenses: item.purchasedLicenses,
                //        purchasedServices: item.purchasedServices,
                //        purchasedSupports: item.purchasedSupports,
                //    }
                //});
                return [2 /*return*/, {
                        list: data.list,
                        count: data.totalRow,
                        page: pageNumber
                    }];
            case 3:
                e_3 = _a.sent();
                console.error(e_3);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchTicketsByUserId = fetchTicketsByUserId;
var fetchTicket = function (ticketId) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket";
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url + "/" + ticketId)];
            case 2:
                response = _a.sent();
                item = response.data;
                console.log(item.comments);
                return [2 /*return*/, item];
            case 3:
                e_4 = _a.sent();
                console.error(e_4);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchTicket = fetchTicket;
var postTicket = function (userId, obj) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                debugger;
                API = "/api/ticket";
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post(url + "/" + userId, obj)];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_5 = _a.sent();
                console.error(e_5);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.postTicket = postTicket;
var deleteTicket = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket";
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.delete(url + "/" + id)];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_6 = _a.sent();
                console.error(e_6);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.deleteTicket = deleteTicket;
var replyTicketComment = function (ticketId, obj, headerObj) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/comment";
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.post(url + "/" + ticketId, obj, {
                        headers: headerObj
                    })];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_7 = _a.sent();
                console.error(e_7);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.replyTicketComment = replyTicketComment;
var updateTicketStatus = function (ticketId, flag, userId) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/status/" + ticketId + "/" + userId + "/" + flag;
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url + "/")];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_8 = _a.sent();
                console.error(e_8);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.updateTicketStatus = updateTicketStatus;
var updateResolutionTime = function (ticketId, type, time) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/resolution/" + ticketId + "/" + type + "/" + time;
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url + "/")];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_9 = _a.sent();
                console.error(e_9);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.updateResolutionTime = updateResolutionTime;
var fetchSLAStatus = function (ticketId) { return __awaiter(void 0, void 0, void 0, function () {
    var API, BASE_URL, url, response, item, e_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                API = "/api/ticket/sla/" + ticketId;
                BASE_URL = authConfig_1.apiConfig.basePath;
                url = BASE_URL + API;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, axios_1.default.get(url + "/")];
            case 2:
                response = _a.sent();
                item = response.data;
                return [2 /*return*/, item];
            case 3:
                e_10 = _a.sent();
                console.error(e_10);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.fetchSLAStatus = fetchSLAStatus;
var convertStatusEnumToString = function (enumStatus) {
    var str = "";
    switch (enumStatus) {
        case 0:
            str = "Inactive";
            break;
        case 1:
            str = "Active";
            break;
        case 2:
            str = "Disabled";
            break;
        default:
    }
    return str;
};
//# sourceMappingURL=ticket.js.map